import { UpdateRoleBody } from '@/services/Hub/Authorization/contract/request/role.request'
import { RoleDTO } from '@/services/Hub/Authorization/contract/response/roles.response'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
  Typography
} from '@mui/material'
import { useEffect, useState } from 'react'

interface RoleCopyModalProps {
  open: boolean
  onClose: () => void
  role: RoleDTO
  submitForm: (roleToSubmit: UpdateRoleBody) => void
}

export const RoleCopyModal = (props: RoleCopyModalProps) => {
  const { open, onClose, role, submitForm } = props
  const [newRoleName, setNewRoleName] = useState('')
  const [isCopying, setIsCopying] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (open && role?.label) {
      setNewRoleName(`${role.label} - cópia`)
      setError(null)
    }
  }, [open, role])

  const handleCopyRole = async () => {
    if (!role || !submitForm || !newRoleName.trim()) return

    setIsCopying(true)
    setError(null)

    try {
      const { id, ...roleWithoutId } = role
      const newRole = {
        ...roleWithoutId,
        label: newRoleName.trim()
      }
      await submitForm(newRole)
      onClose()
    } catch (err) {
      console.error(err)
      setError('Erro ao duplicar o cargo.')
    } finally {
      setIsCopying(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="copy-role-dialog-title">
      <DialogTitle id="copy-role-dialog-title">Cargo duplicado: {role?.label}</DialogTitle>
      <form
        onSubmit={e => {
          e.preventDefault()
          handleCopyRole()
        }}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nome do novo cargo"
            type="text"
            fullWidth
            variant="outlined"
            value={newRoleName}
            onChange={e => setNewRoleName(e.target.value)}
          />
          {error && (
            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isCopying || !newRoleName.trim()}>
            {isCopying ? <CircularProgress size={20} sx={{ ml: 1 }} /> : 'Confirmar'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}
